import { track } from 'src/lib/analytics/utils';

/**
 * Trigger on friend visit list has shown up
 *
 * @param numLineFriends - Number of LINE friends listed
 * @param numOtherPlayers - Number of other players listed
 */
export function trackFriendVisitTargetListOpenEvent(eventProperties: {
  numLineFriends: number;
  numOtherPlayers: number;
}) {
  track('FriendVisitTargetListOpen', eventProperties);
}

/**
 * Player switches to the Visitors tab within PopupVisitFriend
 */
export function trackVisitorListOpenEvent(eventProperties: {
  visitorCount: number;
  recentVisitors: number;
}) {
  track('VisitorListOpen', eventProperties);
}

// Trigger on reviving friend pet
export function trackReviveFriendPet(props: {
  friendID: string;
  petAge: number;
  daysElapsedLastEntry: number;
  daysSincePetDie: number;
}) {
  track('TrackReviveFriendPet', props);
}
